import qs from "qs";
let query = qs.parse(location.search.slice(1));

export function getDefaultParam() {
    let param = {};

    if (query.source == "APP") {
        param.source = "APP";
        param.token = query.token;
        param.userId = query.userId || getUserIdAsToken(query.token);
    } else if (query.source == "WX") {
        param.source = "WX";
        param.unionid = query.unionid;
        if (query.type == 2 || query.type == 3) {
            param.memberId = query.ma_id;
            param.sign = query.ma_sign;
        }
    } else if (query.source == "MINI_PROGRAM") {
        param.source = "MINI_PROGRAM";
        param.token = query.token;
        param.userCode = query.userCode;
    } else {
        param.source = "H5";
        param.token = localStorage.getItem("INVERTADVISER_TOKEN") || "";
    }

    return param;
}
export function getUserIdAsToken(token = "") {
    const str = token.split(".")[1];
    if (!str) return "";
    const info = JSON.parse(window.atob(str)) || {};
    return info.userId;
}
export function birthdayToAge(date) {
    date = new Date(date);
    let nowDate = new Date();
    let curYear = nowDate.getFullYear();
    let year = date.getFullYear();
    let leftYear = curYear - year;
    let newDate = new Date(curYear, date.getMonth(), date.getDate());
    // nowDate = new Date(curYear,nowDate.getMonth(),nowDate.getDate());
    let leftTime = nowDate.getTime() - newDate.getTime();
    let age = leftTime > 0 ? leftYear : leftYear - 1;
    return age;
}
